export interface ClientExtendedInformation {
  id: string
  text: string
  sort: number
}

export interface IClient {
  id: string
  businessAddress: string
  businessCity: string
  businessZip: string
  clientName: string
  clientNo: number
  clientType: {
    code: string
    description: string
    companyTypeCode: CompanyTypeEnum
  }
  code: string
  description: string
  companyNumber: string
  countryCode: string
  epost: string
  foundedDate: Date
  invoiceAddress: string
  invoiceCity: string
  invoiceZip: string
  invoiceCountryCode: string
  jointDebt: number
  lastChangeForetakReg: string
  mainClient: number
  postalCode: number
  vatEligible: boolean
  website: string
  emailInvoiceReception: string
  lastStatuteChangedDate: Date
  extendedInformation: ClientExtendedInformation[]
  normalOperationsDate: Date
  totalInsuranceProviderId: string
  advisorsGrantedFullAccessOnStyreportal: boolean
  hasLightSystem: boolean
}

export interface IClientWithSettings extends IClient {
  portalAvailable: string[]
}

export enum CompanyTypeEnum {
  BBL = 'BBL', // Boligbyggerlag
  BRL = 'BRL', // Borettslag
  ESS = 'ESS', // Eierseksjonsameie
  BAS = 'BAS', // Boligaksjeselskap
  AS = 'AS', // Aksjeselskap
  TRS = 'TRS', // Tingsrettsligsameie,
  SA = 'SA', // Samvirke
  STI = 'STI', // Stiftelse
  FO = 'FO', // Forening
}

export interface IClientSettings {
  portalAvailableIds: string[]
  id: string
}

export interface SimpleClient {
  id: string
  no: number
  name: string
  sortKey?: string
}
